import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../utils/request';
import { METHOD_POST } from '../../constants/api';
import getArticlesTheme from './getArticlesTheme';

export const clearPostThemeData = createAction('articles/clearPostThemeData');

const postArticlesTheme = createAsyncThunk('articles/postArticlesTheme',
  async (formData = {}, { rejectWithValue, dispatch }) => {
    try {
      const data = await authSet(METHOD_POST, '/articles/theme', formData);
      dispatch(getArticlesTheme());
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default postArticlesTheme;
